import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { initialize } from '../../store/env/env.js';
import { signedInExistingUser } from '../../store/auth/auth.js';

/**
 * Host integration shared by the `sdb-embedded-*` elements, this package's public API.
 *
 * A host (learning-leerplatform, or the SPA in apps/composition-editor) passes
 * `.settings` and `.user`. The element feeds them into this package's own store and
 * stays empty until the environment is known, so the inner components can rely on
 * `state.env.settings` and `state.auth.user`.
 *
 * Subclasses render `nothing` while `!this.ready` and may narrow `isReady(state)`.
 */
export const EmbeddedHost = (base) => class extends connect(store)(base) {
    static properties = {
        settings: { type: Object },
        user: { type: Object },
        ready: { state: true },
    };

    constructor() {
        super();

        this.ready = false;
    }

    /** The store state this element needs before it renders; extend in a subclass. */
    isReady(state) {
        return !!state.env.settings;
    }

    stateChanged(state) {
        this.ready = this.isReady(state);
    }

    firstUpdated(changedProperties) {
        super.firstUpdated?.(changedProperties);

        if (this.settings) {
            store.dispatch(initialize({ settings: this.settings }));
        }
    }

    updated(changedProperties) {
        super.updated?.(changedProperties);

        if (changedProperties.has('user')) {
            store.dispatch(signedInExistingUser({ user: this.user }));
        }
    }
};
